import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 韩漫大全',
  description: '韩漫大全致力于打造无删减韩国漫画下拉式免费阅读平台，为中文读者提供最优质的韩国漫画阅读体验。',
  url: 'https://www.hanmandq.com/about',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫大全',
    url: 'https://www.hanmandq.com/',
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.hanmandq.com/' },
    { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.hanmandq.com/about' },
  ],
};

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 md:pt-24">
          <section className="py-10 md:py-14 bg-background-50">
            <div className="w-full max-w-5xl mx-auto px-6 md:px-10">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8">
                <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-900 font-medium">关于我们</span>
              </nav>

              <h1 className="text-3xl md:text-4xl font-display font-bold text-foreground-900 mb-4">
                关于韩漫大全
              </h1>
              <p className="text-base text-foreground-600 mb-10 leading-relaxed max-w-2xl">
                韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，为中文读者提供最优质的韩国漫画阅读体验
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
                <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                    <i className="ri-book-read-line text-2xl text-primary-600"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-2">丰富资源</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    汇集超过200部精选韩国漫画，涵盖恋爱、奇幻、动作、悬疑等多种类型。每一部漫画均为无删减版本，原汁原味呈现韩国漫画的精髓。
                  </p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                  <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mb-4">
                    <i className="ri-smartphone-line text-2xl text-accent-600"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-2">下拉式阅读</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    采用韩国网漫标志性的下拉式阅读方式，无需翻页即可连续浏览。针对移动端和桌面端深度优化，无论什么设备都能享受流畅的阅读体验。
                  </p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                  <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-2xl text-secondary-600"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-2">纯净体验</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们坚持纯净无广告的阅读环境，让您专注于漫画本身。没有弹窗、没有诱导广告、没有杂乱信息，只有纯粹的韩国漫画阅读享受。
                  </p>
                </div>
              </div>

              <div className="mb-14">
                <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground-900 mb-8">
                  我们的口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="p-5 rounded-xl bg-background-50 border border-background-200">
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      &ldquo;终于找到了一个真正无删减的韩国漫画网站！下拉式阅读太方便了，手机上也能看得很舒服。资源也非常全，强烈推荐！&rdquo;
                    </p>
                    <p className="text-xs text-foreground-400">—— 漫画爱好者 小王</p>
                  </div>
                  <div className="p-5 rounded-xl bg-background-50 border border-background-200">
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      &ldquo;作为韩漫老粉，这个网站真的让我惊喜。没有广告干扰，更新速度也很快，下拉式阅读体验比在其他平台看舒服太多了。&rdquo;
                    </p>
                    <p className="text-xs text-foreground-400">—— 资深读者 小李</p>
                  </div>
                  <div className="p-5 rounded-xl bg-background-50 border border-background-200">
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      &ldquo;免费韩漫大全这一点太良心了！所有漫画都能免费看，而且都是无删减版本。页面设计也很干净整洁，阅读体验一级棒。&rdquo;
                    </p>
                    <p className="text-xs text-foreground-400">—— 忠实用户 小张</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground-900 mb-8">
                  联系我们
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                    <h3 className="text-lg font-semibold text-foreground-900 mb-4">平台信息</h3>
                    <ul className="space-y-3 text-sm text-foreground-600">
                      <li className="flex items-start gap-3">
                        <i className="ri-global-line text-primary-500 mt-0.5"></i>
                        <span>韩漫大全 - 韩国漫画无删减下拉式免费阅读平台</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                        <span>contact@hanmandq.com</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-time-line text-primary-500 mt-0.5"></i>
                        <span>客服时间：周一至周日 9:00 - 21:00</span>
                      </li>
                    </ul>
                  </div>
                  <div className="p-6 rounded-xl bg-background-100 border border-background-200">
                    <h3 className="text-lg font-semibold text-foreground-900 mb-4">版权声明</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      本站所有韩国漫画内容均来自原作者授权或公开渠道，仅供学习交流使用。如涉及版权问题，请通过上述联系方式与我们沟通，我们将在第一时间处理。韩漫网站致力于为读者提供合法、优质的无删减韩国漫画下拉式阅读体验。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}